import React from "react";
import config from "react-global-configuration";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @fullcalendar
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid';
import googleCalendarPlugin from '@fullcalendar/google-calendar';

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import calendarPageStyle from "assets/jss/westmorland-lodge-44/views/calendarPage.jsx";

class CalendarPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );
    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
    return (
      <div>
        <Header
          color="transparent"
          brand={config.get("name")}
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "white"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/bg/landing-bg.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h2 className={classes.title}>Calendar of Events</h2>
                <br />
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <FullCalendar
            defaultView="dayGridMonth"
            header={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,listWeek'
            }}
            googleCalendarApiKey="AIzaSyAmqZr-zfMr8eBWzaUoWjVXOY_CYDtT4-c"
            events={{
              googleCalendarId: 'r5ei078th3fjj5cohbgih0b2ls@group.calendar.google.com'
            }}
            plugins={[ dayGridPlugin, googleCalendarPlugin ]}
            eventClick={function(info) {
              info.jsEvent.preventDefault(); // don't let the browser navigate
              if (info.event.url) {
                window.open(info.event.url);
              }
            }}
          />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(calendarPageStyle)(CalendarPage);



// WEBPACK FOOTER //
// ./src/views/CalendarPage/CalendarPage.jsx